module.exports = __webpack_public_path__ + "static/media/JohnMcclane.e9cd247a.jpg";